import React, { useContext, useEffect, useRef, useState } from "react";
import { i18n } from "../../translate/i18n";
import { AuthContext } from "../../context/Auth/AuthContext";
import UserLanguageSelector from "../../components/UserLanguageSelector";
import NotificationsPopOver from "../../components/NotificationsPopOver";
import AppTopbarSearch from "../../components/AppTopbarSearch";
import { IconAccount } from "../SidebarIcons";
import { getSystemVersionLabel } from "../../helpers/systemInfo";
import packageJson from "../../../package.json";
import AIManagerModal from "../../components/ModalGerenciadorIa/AIManagerModal";

const { system } = packageJson;

function IconMenuToggle() {
	return (
		<svg className="size-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
			<line x1="3" y1="6" x2="21" y2="6" />
			<line x1="3" y1="12" x2="21" y2="12" />
			<line x1="3" y1="18" x2="21" y2="18" />
		</svg>
	);
}

function IconSun() {
	return (
		<svg
			className="absolute size-5 scale-100 rotate-0 transition-all duration-200 dark:scale-0 dark:-rotate-90"
			viewBox="0 0 24 24"
			fill="none"
			stroke="currentColor"
			strokeWidth="2"
		>
			<circle cx="12" cy="12" r="5" />
			<line x1="12" y1="1" x2="12" y2="3" />
			<line x1="12" y1="21" x2="12" y2="23" />
			<line x1="4.22" y1="4.22" x2="5.64" y2="5.64" />
			<line x1="18.36" y1="18.36" x2="19.78" y2="19.78" />
			<line x1="1" y1="12" x2="3" y2="12" />
			<line x1="21" y1="12" x2="23" y2="12" />
			<line x1="4.22" y1="19.78" x2="5.64" y2="18.36" />
			<line x1="18.36" y1="5.64" x2="19.78" y2="4.22" />
		</svg>
	);
}

function IconMoneyIA() {
	return (
		<svg
			className="size-7"
			viewBox="0 0 256 256"
			xmlns="http://www.w3.org/2000/svg"
			aria-hidden="true"
		>
			<defs>
				<linearGradient id="ai-money-gold" x1="0%" y1="0%" x2="100%" y2="100%">
					<stop offset="0%" stopColor="#FFD95A" />
					<stop offset="50%" stopColor="#F4B400" />
					<stop offset="100%" stopColor="#C98A00" />
				</linearGradient>

				<linearGradient id="ai-money-inner" x1="0%" y1="0%" x2="100%" y2="100%">
					<stop offset="0%" stopColor="#FFE58A" />
					<stop offset="100%" stopColor="#F2B600" />
				</linearGradient>
			</defs>

			<circle cx="128" cy="128" r="112" fill="url(#ai-money-gold)" />
			<circle
				cx="128"
				cy="128"
				r="98"
				fill="url(#ai-money-inner)"
				stroke="#B57A00"
				strokeWidth="6"
			/>

			<circle
				cx="128"
				cy="128"
				r="82"
				fill="none"
				stroke="#FFF3B0"
				strokeWidth="4"
				strokeDasharray="6 8"
			/>

			<rect
				x="92"
				y="92"
				width="72"
				height="72"
				rx="12"
				fill="#222"
			/>

			<g stroke="#222" strokeWidth="4">
				<line x1="108" y1="80" x2="108" y2="92" />
				<line x1="128" y1="80" x2="128" y2="92" />
				<line x1="148" y1="80" x2="148" y2="92" />

				<line x1="108" y1="164" x2="108" y2="176" />
				<line x1="128" y1="164" x2="128" y2="176" />
				<line x1="148" y1="164" x2="148" y2="176" />

				<line x1="80" y1="108" x2="92" y2="108" />
				<line x1="80" y1="128" x2="92" y2="128" />
				<line x1="80" y1="148" x2="92" y2="148" />

				<line x1="164" y1="108" x2="176" y2="108" />
				<line x1="164" y1="128" x2="176" y2="128" />
				<line x1="164" y1="148" x2="176" y2="148" />
			</g>

			<text
				x="128"
				y="138"
				textAnchor="middle"
				fontSize="28"
				fontFamily="Arial"
				fontWeight="bold"
				fill="#FFD54F"
			>
				AI
			</text>

			<g stroke="#FFF8D6" strokeWidth="3" fill="#FFF8D6">
				<line x1="128" y1="46" x2="128" y2="24" />
				<circle cx="128" cy="20" r="4" />

				<line x1="210" y1="128" x2="232" y2="128" />
				<circle cx="236" cy="128" r="4" />

				<line x1="128" y1="210" x2="128" y2="232" />
				<circle cx="128" cy="236" r="4" />

				<line x1="46" y1="128" x2="24" y2="128" />
				<circle cx="20" cy="128" r="4" />
			</g>
		</svg>
	);
}


function IconMoon() {
	return (
		<svg
			className="absolute size-5 scale-0 -rotate-90 transition-all duration-200 dark:scale-100 dark:rotate-0"
			viewBox="0 0 24 24"
			fill="none"
			stroke="currentColor"
			strokeWidth="2"
		>
			<path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z" />
		</svg>
	);
}

const STATUS_DOT = {
	online: "#22c55e",
	busy: "#eab308",
	offline: "#ef4444",
};

function IconPanelLeft() {
	return (
		<svg className="size-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
			<rect x="3" y="3" width="18" height="18" rx="2" />
			<path d="M9 3v18" />
		</svg>
	);
}

export default function AppTopbar({
	onToggleSidenav,
	sidenavCollapsed,
	darkMode,
	onToggleDarkMode,
	onOpenAccount,
	onLogout,
	onUpdateStatus,
}) {
	const { user } = useContext(AuthContext);
	const [menuOpen, setMenuOpen] = useState(false);
	const menuRef = useRef(null);
	const [modalIa, setModalIA] = useState(false)
	const [tokens, setTokens] = useState([])
	useEffect(() => {
		const onDocClick = (e) => {
			if (menuRef.current && !menuRef.current.contains(e.target)) {
				setMenuOpen(false);
			}
		};
		document.addEventListener("mousedown", onDocClick);
		return () => document.removeEventListener("mousedown", onDocClick);
	}, []);

	const statusColor = STATUS_DOT[user?.status] || STATUS_DOT.offline;

	return (
		<header className="app-header sticky top-0 z-30 box-border flex h-topbar-height min-h-topbar-height max-h-topbar-height shrink-0 items-center">
			<div className="flex w-full items-center justify-between gap-4 px-4 sm:px-6">
				<div className="flex min-w-0 items-center gap-4">
					<button
						type="button"
						id="button-toggle-menu"
						className="btn btn-icon size-8 shrink-0 rounded"
						onClick={onToggleSidenav}
						aria-label={i18n.t("master.layout.toggleMenu")}
						aria-pressed={sidenavCollapsed}
						title={i18n.t("master.layout.toggleMenu")}
					>
						<span className="lg:hidden">
							<IconMenuToggle />
						</span>
						<span className="hidden lg:inline-flex">
							<IconPanelLeft />
						</span>
					</button>

					<AppTopbarSearch variant="app" />
				</div>

				<div className="flex items-center gap-2 sm:gap-3">


					<div className="topbar-item flex items-center gap-1.5">
						<button
							type="button"
							className="btn btn-icon relative inline-flex size-9 items-center justify-center rounded-full hover:bg-default-150"
							onClick={() => setModalIA(!modalIa)}
							aria-label={i18n.t("master.layout.ModalIa")}
						>
							<IconMoneyIA />
						</button>

						<AIManagerModal open={modalIa} onClose={() => setModalIA(false)} setTokens={setTokens} />
						<p className="m-0 text-xs font-medium text-default-600 dark:text-default-300">
							{`${tokens[0] > 0
								? (((tokens[0] - tokens[1]) / tokens[0]) * 100).toFixed(0)
								: 0
								}%`}
						</p>
					</div>

					<div className="topbar-item app-topbar-lang">
						<UserLanguageSelector variant="topbar" darkMode={darkMode} />
					</div>

					<div className="topbar-item">
						<button
							type="button"
							className="btn btn-icon relative size-8 rounded-full hover:bg-default-150"
							onClick={onToggleDarkMode}
							aria-label={i18n.t("master.layout.toggleTheme")}
						>
							<IconSun />
							<IconMoon />
						</button>
					</div>

					<NotificationsPopOver variant="topbar" />

					<div className="topbar-item relative" ref={menuRef}>
						<button
							type="button"
							className="relative flex size-9 shrink-0 items-center justify-center overflow-visible rounded-full bg-primary/15 text-primary ring-2 ring-primary/20 hover:bg-primary/25"
							onClick={() => setMenuOpen((v) => !v)}
							aria-expanded={menuOpen}
							aria-haspopup="true"
							aria-label={user?.name || "Conta"}
						>
							<IconAccount />
							<span
								className="app-user-menu__status-dot app-user-menu__status-dot--avatar ring-2 ring-white dark:ring-default-800"
								style={{ backgroundColor: statusColor }}
								aria-hidden
							/>
						</button>
						{menuOpen && (
							<div
								className="app-user-menu absolute end-0 top-[calc(100%+8px)] z-50 min-w-52 overflow-hidden rounded-md border py-1 shadow-lg"
								role="menu"
							>
								<div className="app-user-menu__head border-b px-4 py-3">
									<p className="m-0 text-sm font-semibold">{user?.name}</p>
									<p className="m-0 mt-0.5 truncate text-xs opacity-70">{user?.email}</p>
								</div>
								<p className="m-0 px-4 py-2 text-xs font-semibold uppercase text-default-500">
									Defina como
								</p>
								<button
									type="button"
									className="app-user-menu__item flex w-full items-center gap-2 px-4 py-2 text-left text-sm font-medium transition-colors"
									onClick={() => {
										onUpdateStatus("online");
										setMenuOpen(false);
									}}
								>
									<span className="app-user-menu__status-dot" style={{ backgroundColor: STATUS_DOT.online }} />
									Disponível
								</button>
								<button
									type="button"
									className="app-user-menu__item flex w-full items-center gap-2 px-4 py-2 text-left text-sm font-medium transition-colors"
									onClick={() => {
										onUpdateStatus("busy");
										setMenuOpen(false);
									}}
								>
									<span className="app-user-menu__status-dot" style={{ backgroundColor: STATUS_DOT.busy }} />
									Ocupado
								</button>
								<button
									type="button"
									className="app-user-menu__item flex w-full items-center gap-2 px-4 py-2 text-left text-sm font-medium transition-colors"
									onClick={() => {
										onUpdateStatus("offline");
										setMenuOpen(false);
									}}
								>
									<span className="app-user-menu__status-dot" style={{ backgroundColor: STATUS_DOT.offline }} />
									Desconectado
								</button>
								<div className="my-1 border-t border-default-200 dark:border-default-700" />
								<div className="px-4 py-2.5 text-xs text-default-500">
									<span className="block font-medium text-default-600 dark:text-default-400">
										{i18n.t("layout.topbarSearch.systemVersion")}
									</span>
									<span className="mt-0.5 block">
										{system.name} ({getSystemVersionLabel()})
									</span>
								</div>
								<div className="my-1 border-t border-default-200 dark:border-default-700" />
								<button
									type="button"
									className="app-user-menu__item flex w-full items-center gap-2 px-4 py-2 text-left text-sm font-medium transition-colors"
									onClick={() => {
										setMenuOpen(false);
										onOpenAccount();
									}}
								>
									<IconAccount />
									{i18n.t("mainDrawer.appBar.user.profile")}
								</button>
								<button
									type="button"
									className="app-user-menu__item app-user-menu__item--danger flex w-full items-center gap-2 px-4 py-2 text-left text-sm font-medium transition-colors"
									onClick={() => {
										setMenuOpen(false);
										onLogout();
									}}
								>
									{i18n.t("mainDrawer.appBar.user.logout")}
								</button>
							</div>
						)}
					</div>
				</div>
			</div>
		</header>
	);
}
